import { Component, Input } from '@angular/core';

@Component({
  selector: 'wl-skeleton-loading-card',
  templateUrl: './skeleton-loading-card.component.html',
  styleUrls: [
    './skeleton-loading-card.component.ed.scss',
    './skeleton-loading-card.component.essent.scss',
  ],
})
export class SkeletonLoadingCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public amountOfLines = 4;

  get arrayOfLines() {
    return Array(this.amountOfLines);
  }
}
